{
  "help": "Palīdzība",
  "info": "Informācija"
}
